export default "__VITE_ASSET__C8h6lpMC__"